import { MoreHorizontal, ChevronDown } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecentTools } from "@/hooks/use-recent-tools";
import { primaryNav, secondaryNav } from "@/lib/nav-items";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const TopNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { trackVisit } = useRecentTools();

  const isMoreActive = secondaryNav.some(item => item.path === location.pathname);
  const activeSecondary = secondaryNav.find(item => item.path === location.pathname);

  return (
    <header className="hidden md:block fixed top-0 left-0 right-0 bg-card border-b border-border z-50" role="banner">
      <nav className="max-w-7xl mx-auto flex items-center h-12 px-4 gap-1" aria-label="Main navigation">
        {primaryNav.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => { trackVisit(item.path, item.label); navigate(item.path); }}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
                isActive
                  ? "bg-primary/10 text-primary"
                  : "text-muted-foreground hover:bg-secondary hover:text-foreground"
              }`}
              aria-current={isActive ? "page" : undefined}
            >
              <item.icon className="w-4 h-4" />
              <span>{item.label}</span>
            </button>
          );
        })}

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
                isMoreActive
                  ? "bg-primary/10 text-primary"
                  : "text-muted-foreground hover:bg-secondary hover:text-foreground"
              }`}
              aria-label="More tools"
            >
              <MoreHorizontal className="w-4 h-4" />
              <span>{activeSecondary?.label ?? "More"}</span>
              <ChevronDown className="w-3 h-3 opacity-60" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" className="w-60">
            {secondaryNav.map((item) => (
              <DropdownMenuItem
                key={item.path}
                onSelect={() => { trackVisit(item.path, item.label); navigate(item.path); }}
                className={`gap-2.5 cursor-pointer ${location.pathname === item.path ? "text-primary" : ""}`}
              >
                <item.icon className="w-4 h-4 shrink-0" />
                <div>
                  <div className="text-sm font-medium leading-tight">{item.label}</div>
                  <div className="text-[11px] text-muted-foreground leading-tight">{item.desc}</div>
                </div>
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </nav>
    </header>
  );
};

export default TopNav;
